<template>
  <div>
    <el-dialog
      title="选择医院"
      width="40%"
      :before-close="handleClose"
      :visible.sync="isOpen"
      :close-on-click-modal="false"
    >
      <div class="title">您可以进入以下医院</div>
      <div v-for="(item,index) in hospitalData" :key="index" class="list" :class="radio==item.id?'active':''" @click="changeHospital(item.id)">
        <div class="info">
          <img src="@/assets/img/default.png" class="avtar">
          {{ item.title }}
        </div>
        <img v-if="radio==item.id" src="@/assets/img/checked.png" class="check_img">
        <img v-else src="@/assets/img/uncheck.png" class="check_img">
        <!-- <el-radio v-model="radio" :label="String(item.id)" style="color: #fff; padding-left: 10px;">&nbsp;</el-radio> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="handleClose">取 消</el-button>
        <el-button class="sure" type="primary" @click="saveId">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    showHospital: {
      default: false,
      type: Boolean
    },
    hospitalData: {
      type: Array,
      default() { return [] }
    }
  },
  data() {
    return {
      radio: ''
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.showHospital;
      },
      set(val) {
        this.$emit("update:showHospital", val);
      }
    }
  },
  watch: {
    'showHospital': {
      handler(newSrc, oldSrc) {
        if (newSrc) {
          this.radio = localStorage.getItem('hospital_id')
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.isOpen = false;
      this.radio = ''
    },
    changeHospital(id) {
      this.radio = String(id)
    },
    saveId() {
      if (!this.radio) {
        return this.$message.error('请先选择医院')
      }
      this.$emit('saveId', this.radio)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .el-dialog__body{
    padding-bottom: 0;
  }
}
.title{
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #303030;
    margin-bottom: 16px;
}
.list{
    padding: 16px 24px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #EEEEEE;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #303030;
    .info{

        display: flex;
        align-items: center;
        .avtar{
            width: 32px;
            margin-right: 8px;
        }
    }
    .check_img{
      width: 16px;
    }
}
.active{
    border: 1px solid #DD594A;
    color: #DD594A;
}
</style>
